// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wizzy landing — dark blueprint hero with interactive swirl trails */

.login-container {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(1000px 600px at 8% -12%, rgba(182, 206, 59, 0.14) 0%, rgba(182, 206, 59, 0) 60%),
    radial-gradient(820px 560px at 108% 112%, rgba(182, 206, 59, 0.09) 0%, rgba(182, 206, 59, 0) 55%),
    linear-gradient(160deg, #14180f 0%, #0e120b 55%, #10150c 100%);
}

/* Fine blueprint grid, barely-there */
.login-container::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(182, 206, 59, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(182, 206, 59, 0.05) 1px, transparent 1px),
    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 132px 132px, 132px 132px, 22px 22px, 22px 22px;
  mask-image: radial-gradient(ellipse 90% 80% at 50% 45%, #000 30%, transparent 100%);
  -webkit-mask-image: radial-gradient(ellipse 90% 80% at 50% 45%, #000 30%, transparent 100%);
  pointer-events: none;
}

/* Swirl layer sits above the grid, below the content */
.login-swirl {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.login-swirl canvas {
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: none;
}

/* Layout ------------------------------------------------------------ */

.login-stage {
  position: relative;
  z-index: 2;
  min-height: 100vh;
  max-width: 1120px;
  margin: 0 auto;
  padding: 48px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 72px;
}

/* Hero -------------------------------------------------------------- */

.login-hero {
  flex: 1.15 1;
  max-width: 560px;
}

.login-hero-logo {
  height: 26px;
  width: auto;
  display: block;
  margin-bottom: 34px;
  filter: brightness(0) invert(1);
  opacity: 0.9;
}

.login-hero-title {
  font-size: clamp(58px, 7.5vw, 92px);
  color: #f6f8ee;
  margin-bottom: 22px;
  text-shadow: 0 0 60px rgba(182, 206, 59, 0.25);
}

.login-hero-tagline {
  font-size: clamp(19px, 2vw, 23px);
  line-height: 1.45;
  color: rgba(244, 246, 236, 0.84);
  margin: 0 0 12px;
  font-weight: 500;
  letter-spacing: -0.01em;
  max-width: 30ch;
}

.login-hero-accent {
  background: linear-gradient(92deg, #dcee7a 0%, #b6ce3b 55%, #93b31f 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  font-weight: 600;
}

.login-hero-sub {
  font-size: 15px;
  line-height: 1.6;
  color: rgba(244, 246, 236, 0.5);
  margin: 0;
  max-width: 44ch;
}

/* Card -------------------------------------------------------------- */

.login-content {
  flex: none;
  width: 100%;
  max-width: 400px;
}

.login-card {
  border-radius: 18px !important;
  border: 1px solid rgba(255, 255, 255, 0.09) !important;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.06),
    0 24px 64px rgba(0, 0, 0, 0.5),
    0 4px 16px rgba(0, 0, 0, 0.35),
    0 0 120px rgba(182, 206, 59, 0.10) !important;
}

.login-card .ant-card-body {
  padding: 34px 36px 22px;
}

.login-subtitle {
  display: block;
  text-align: center;
  margin-bottom: 28px;
}

.login-button {
  height: 44px;
  font-size: 15px;
}

/* Footer mark ------------------------------------------------------- */

.login-footer {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(244, 246, 236, 0.38);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.login-footer-sep {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(244, 246, 236, 0.22);
}

.login-footer-flag {
  width: 12px;
  height: 12px;
  display: block;
  border-radius: 3.5px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);
  opacity: 0.9;
}

/* Responsive -------------------------------------------------------- */

/* Short windows: trim the hero padding so the footer mark stays in view */
@media (max-height: 780px) {
  .login-stage {
    padding-top: 32px;
    padding-bottom: 56px;
  }

  .login-hero-title {
    margin-bottom: 16px;
  }
}

@media (max-width: 960px) {
  .login-stage {
    flex-direction: column;
    gap: 40px;
    padding: 56px 24px 64px;
  }

  .login-hero {
    max-width: 460px;
    text-align: center;
  }

  .login-hero-logo {
    margin-left: auto;
    margin-right: auto;
  }

  .login-hero-title {
    justify-content: center;
    width: 100%;
  }

  .login-hero-tagline,
  .login-hero-sub {
    margin-left: auto;
    margin-right: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB;;;kEAGgE;AAClE;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;2EAIyE;EACzE,+DAA+D;EAC/D,mFAAmF;EACnF,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA,wEAAwE;;AAExE;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,wEAAwE;;AAExE;EACE,YAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yEAAyE;EACzE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,eAAe;AACjB;;AAEA,wEAAwE;;AAExE;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD;;;;iDAI+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,wEAAwE;;AAExE;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,+CAA+C;EAC/C,YAAY;AACd;;AAEA,wEAAwE;;AAExE,0EAA0E;AAC1E;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":["/* Wizzy landing — dark blueprint hero with interactive swirl trails */\n\n.login-container {\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(1000px 600px at 8% -12%, rgba(182, 206, 59, 0.14) 0%, rgba(182, 206, 59, 0) 60%),\n    radial-gradient(820px 560px at 108% 112%, rgba(182, 206, 59, 0.09) 0%, rgba(182, 206, 59, 0) 55%),\n    linear-gradient(160deg, #14180f 0%, #0e120b 55%, #10150c 100%);\n}\n\n/* Fine blueprint grid, barely-there */\n.login-container::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(182, 206, 59, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(182, 206, 59, 0.05) 1px, transparent 1px),\n    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);\n  background-size: 132px 132px, 132px 132px, 22px 22px, 22px 22px;\n  mask-image: radial-gradient(ellipse 90% 80% at 50% 45%, #000 30%, transparent 100%);\n  -webkit-mask-image: radial-gradient(ellipse 90% 80% at 50% 45%, #000 30%, transparent 100%);\n  pointer-events: none;\n}\n\n/* Swirl layer sits above the grid, below the content */\n.login-swirl {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.login-swirl canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n  pointer-events: none;\n}\n\n/* Layout ------------------------------------------------------------ */\n\n.login-stage {\n  position: relative;\n  z-index: 2;\n  min-height: 100vh;\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 48px 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 72px;\n}\n\n/* Hero -------------------------------------------------------------- */\n\n.login-hero {\n  flex: 1.15;\n  max-width: 560px;\n}\n\n.login-hero-logo {\n  height: 26px;\n  width: auto;\n  display: block;\n  margin-bottom: 34px;\n  filter: brightness(0) invert(1);\n  opacity: 0.9;\n}\n\n.login-hero-title {\n  font-size: clamp(58px, 7.5vw, 92px);\n  color: #f6f8ee;\n  margin-bottom: 22px;\n  text-shadow: 0 0 60px rgba(182, 206, 59, 0.25);\n}\n\n.login-hero-tagline {\n  font-size: clamp(19px, 2vw, 23px);\n  line-height: 1.45;\n  color: rgba(244, 246, 236, 0.84);\n  margin: 0 0 12px;\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  max-width: 30ch;\n}\n\n.login-hero-accent {\n  background: linear-gradient(92deg, #dcee7a 0%, #b6ce3b 55%, #93b31f 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  font-weight: 600;\n}\n\n.login-hero-sub {\n  font-size: 15px;\n  line-height: 1.6;\n  color: rgba(244, 246, 236, 0.5);\n  margin: 0;\n  max-width: 44ch;\n}\n\n/* Card -------------------------------------------------------------- */\n\n.login-content {\n  flex: none;\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-card {\n  border-radius: 18px !important;\n  border: 1px solid rgba(255, 255, 255, 0.09) !important;\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.06),\n    0 24px 64px rgba(0, 0, 0, 0.5),\n    0 4px 16px rgba(0, 0, 0, 0.35),\n    0 0 120px rgba(182, 206, 59, 0.10) !important;\n}\n\n.login-card .ant-card-body {\n  padding: 34px 36px 22px;\n}\n\n.login-subtitle {\n  display: block;\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.login-button {\n  height: 44px;\n  font-size: 15px;\n}\n\n/* Footer mark ------------------------------------------------------- */\n\n.login-footer {\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 10.5px;\n  font-weight: 500;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(244, 246, 236, 0.38);\n  pointer-events: none;\n  user-select: none;\n}\n\n.login-footer-sep {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: rgba(244, 246, 236, 0.22);\n}\n\n.login-footer-flag {\n  width: 12px;\n  height: 12px;\n  display: block;\n  border-radius: 3.5px;\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);\n  opacity: 0.9;\n}\n\n/* Responsive -------------------------------------------------------- */\n\n/* Short windows: trim the hero padding so the footer mark stays in view */\n@media (max-height: 780px) {\n  .login-stage {\n    padding-top: 32px;\n    padding-bottom: 56px;\n  }\n\n  .login-hero-title {\n    margin-bottom: 16px;\n  }\n}\n\n@media (max-width: 960px) {\n  .login-stage {\n    flex-direction: column;\n    gap: 40px;\n    padding: 56px 24px 64px;\n  }\n\n  .login-hero {\n    max-width: 460px;\n    text-align: center;\n  }\n\n  .login-hero-logo {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .login-hero-title {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .login-hero-tagline,\n  .login-hero-sub {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
